import React from "react"
import types from "prop-types"
import { questionShape } from "utils/propTypeShapes"
import { QuestionBranchingConditionalCheck, QuestionContainer } from "shared/form"
import QuestionAnswerField from "views/Forms/FormElements/QuestionAnswerField"

const SubmissionEditQuestion = ({ question, formAnswers, disabled = false }) => {
  const {
    prompt,
    description,
    conditionals = null,
  } = question

  return (
    <QuestionBranchingConditionalCheck conditionals={conditionals} formAnswers={formAnswers}>
      <QuestionContainer
        className="dark edit-submission-question rounded relative w-full"
        prompt={prompt}
        description={description}
      >
        <QuestionAnswerField
          question={question}
          formAnswers={formAnswers}
          disabled={disabled}
          edit
        />
      </QuestionContainer>
    </QuestionBranchingConditionalCheck>
  )
}

SubmissionEditQuestion.propTypes = {
  question: questionShape.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formAnswers: types.object.isRequired,
  disabled: types.bool,
}

export default SubmissionEditQuestion
